import getItem from './getItem';
import getItemPartId from './getItemPartId';

export default function isLastCourseChapter(toc, itemId) {
  const item = getItem(toc, itemId);

  if (!item) {
    throw new Error('Item not found');
  }

  if (item.type !== 'title-2') {
    return false;
  }

  const partId = getItemPartId(toc, itemId);
  const foundPart = toc.children.find((part) => part.id === partId);
  const chapterIds = foundPart.children
    .filter((partItem) => partItem.type === 'title-2')
    .map((chapter) => chapter.id);

  return chapterIds[chapterIds.length - 1] === itemId;
}
